// Photo tiles for the /web-uploader animations: six small WebP crops of CC0 / public-domain running-event
// photos (credits: src/assets/web-uploader/CREDITS.md). Loaded lazily — see useFigureNear in AnimatedFigure.
import run1 from "@/assets/web-uploader/photos/run-1.webp";
import run2 from "@/assets/web-uploader/photos/run-2.webp";
import run3 from "@/assets/web-uploader/photos/run-3.webp";
import run4 from "@/assets/web-uploader/photos/run-4.webp";
import run5 from "@/assets/web-uploader/photos/run-5.webp";
import run6 from "@/assets/web-uploader/photos/run-6.webp";

export const RUN_PHOTOS = [run1, run2, run3, run4, run5, run6] as const;
export const runPhoto = (i: number) => RUN_PHOTOS[i % RUN_PHOTOS.length];
